import { Box, BoxProps } from '@myn/mui';

import HeaderSkeleton from './HeaderSkeleton.jsx';
import TableSkeleton from './TableSkeleton.jsx';

const PageSkeleton = (props: BoxProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={2} {...props}>
      <HeaderSkeleton />
      <TableSkeleton />
    </Box>
  );
};

export default PageSkeleton;
